<app-subnavegacion
  opcion1="renap"
  opcion2="renec"
></app-subnavegacion>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#ee0909"
  type="ball-atom"
  [fullScreen]="true"
>
  <p style="color: white">cargando ....</p>
</ngx-spinner>

<div class="container">
  <div class="row"></div>

  <div class="title-container">
    <b class="title"
      >RENAC – Registro Nacional de Cursos de Capacitación Basados en Estándares
      de Competencia</b
    >
  </div>

  <app-renac-table-principal
    *ngIf="!selectedCourse"
    (courseSelected)="onCourseSelected($event)"
  ></app-renac-table-principal>

  <app-renac-detalle-curso
    *ngIf="selectedCourse"
    [idCurso]="selectedCourse.idCurso"
    [course]="selectedCourse"
    (closeDetail)="closeDetail()"
  >
  </app-renac-detalle-curso>
</div>
